import {
  GET_MERCHANTS_STATS,
  GET_MERCHANTS_STATS_ERROR
} from "../constants/StatsConstants";

const INITIAL_STATE = {
  merchantStats: [],
  loading: true
};
const merchantStatsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_MERCHANTS_STATS:
      return {
        ...state,
        merchantStats: action.payload,
        loading: false
      };
    case GET_MERCHANTS_STATS_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default merchantStatsReducer;
